<!--
<style lang="less">
  @import './login.less';
</style>
-->
<template>
  <div class="login dddk" :style="{background:'url(' + loginBgImg + ') no-repeat', backgroundPosition:'center', backgroundSize: 'cover'}">
    <div class="name" v-if="false">
      <!-- <strong>美孚OCM油液监测系统</strong> -->
      <img src="@/assets/images/menu-logo.png" alt="美孚OCM油液监测系统">
    </div>
    <div class="login-con">
      <lognleft />
      <Card class="conf-right" :title="null" :bordered="false">
        <h3 class="ddTitle">美孚单点登录</h3>
        <div class="dd-btn form-con">
          <Poptip v-if="!agreement" trigger="hover" content="请先勾选同意用户协议及隐私政策">
            <Button size="large" class="dd-width" :loading="azureLoading" :disabled="!agreement" type="primary" @click="loginAzure">单点登录</Button>
          </Poptip>
          <Button v-if="agreement" class="dd-width" size="large" 
          :loading="azureLoading" :disabled="!agreement" type="primary"
           @click="loginAzure">单点登录</Button>
        </div>
        <div class="agreeItem">
          <template v-if="systemList.title">
            <Checkbox v-model="agreement" size="small"></Checkbox>&nbsp;
            我已阅读并同意<span class="title" @click.self="onSystem">{{"《"+systemList.title+"》"}}</span>及<span class="title" @click.self="onSecrent">{{"《"+secretList.title+"》"}}</span>
          </template>
        </div>
      </Card>
    </div>
    <div v-if="showModal">
      <UseragreementModal ref="useragreementModal" :curItemDetails="curItemDetails" @on-close-cancel="onCloseCancel"></UseragreementModal>
    </div>
  </div>
</template>

<script>
  import api from "@/api";
  import ls from "store2";
  import phoneForm from "@/components/login-form/phone-form.vue";
  import weixinForm from "@/components/login-form/weixin-form.vue";
  import UseragreementModal from "../views/system/components/useragreement-modal.vue";
  import lognleft from '@/components/login-form/logn-left.vue'
  import {
    getCurToken
  } from '@/util/index'
  export default {
    components: {
      phoneForm,
      weixinForm,
      UseragreementModal,
      lognleft
    },
    data() {
      return {
        unionid: null,
        loginBgImg: require("@/assets/images/login-bg.png"),
        agreement: false,
        wxLogin: true,
        ltest: false,
        azureLoading: false,
        isDev: process.env.NODE_ENV === "development",
        systemList: {},
        secretList: {},
        curItemDetails: {},
        showModal: false,
      };
    },
    created() {
     this.init()
    },
    mounted() {
       const token=getCurToken()
  
        if(token){
            this.$router.push("/index")
        }
    },
    methods: {
      init(){
       const urlQuery = this.$router.history.current;
      this.wxLogin = +urlQuery.query.wxlog === 0 ? false : true;
      this.unionid = urlQuery.query.uid;
      this.getSystem();
      this.getSecret();
      },
     
      // 单点登录
      loginAzure() {
        this.azureLoading = true;
        api.axsl("get", "/azure-auth/secure/aad").then((res) => {
     
          if (res.code === "00000") {
            // window.open(res.data, '_blank').focus()
            window.location.href = res.data;
          }
        });
      },
      getSystem() {
        api.axs(
          "get",
          `/ocm-admin/userAgreement/getPrivacyPolicy?type=${1}`
        ).then((res) => {
          if (res.code === "00000") {
            this.systemList = res.data;
          }
        });
      },
      getSecret() {
        api.axs(
          "get",
          `/ocm-admin/userAgreement/getPrivacyPolicy?type=${0}`
        ).then((res) => {
          if (res.code === "00000") {
            this.secretList = res.data;
          }
        });
      },
      onSystem() {
        this.curItemDetails = this.systemList;
        this.showModal = true;
        this.$emit("on-open-modal");
      },
      onSecrent() {
        this.curItemDetails = this.secretList;
        this.showModal = true;
        this.$emit("on-open-modal");
      },
      onCloseCancel(bool) {
        this.showModal = bool;
      },
    },
  };
</script>

<style>
  .dddk .ivu-card-body {
    width: 428px;
    height: 500px;
    background: #fff;
    border-radius: 6px;
  }
</style>
<style lang='less' scoped>
  .login {
    width: 100%;
    height: 100%;
    background-size: cover;
    background-color: #3766ad;
    background-position: center;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;

    .ddTitle {
      text-align: center;
      font-size: 23px;
      color: #373737;
      margin-top: 24px;
    }

    &-con {
      display: flex;
      transform: scale(.9);

      .conf-right {
        width: 475px;
        height: 520px;
        background: #FFFFFF;
        box-shadow: 0px 20px 40px 1px rgba(0, 77, 163, 0.12156862745098039);
        border-radius: 0px 40px 0px 0px;
        opacity: 1;
        overflow: hidden;
      }

      &-header {
        font-size: 16px;
        font-weight: 300;
        text-align: center;
        padding: 30px 0;
      }

      .form-con {
        padding: 10px 0 0;
      }

      .login-tip {
        font-size: 10px;
        text-align: center;
        color: #c3c3c3;
      }
    }

    .dd-btn {
      text-align: center;
      padding: 150px 0 165px 0;
    }

    .dd-width {
      width: 240px;
      height: 64px;
      box-shadow: 0px 3px 12px 1px rgba(0, 0, 0, 0.050980392156862744);
      border-radius: 4px 4px 4px 4px;
      font-size: 20px;
      font-weight: 400;

    }

    .agreeItem {
      height: 21px;
      padding-left: 8px;
      display: flex;
      justify-items: center;
      justify-content: center;
      position: relative;
      top: -10px;

      .ivu-checkbox-wrapper {
        line-height: 20px;
        font-size: 12px;
        padding-right: 0;
        margin-right: 0;

        .ivu-checkbox {
          margin-top: -1px;
        }
      }

      .title {
        color: #0c479da6;
        cursor: pointer;
      }
    }

    .name {
      // position: absolute;
      // left: 50%;
      // margin-left: -150px;
      font-size: 20px;
      color: #fff;
      text-align: left;
      padding: 10px 30px 10px 30px;
      background: #0c479d;

      img {
        width: 184px;
        margin-top: 10px;
        background-repeat: no-repeat;
      }
    }
  }
</style>
